var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 77,
    viewBox: "0 0 109 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623_16124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 22,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2777 14.2853V59.9561H16.7069V26.2049L6.29302 29.2475V21.2175L26.3053 14.2853H27.2777Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623_16124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20.707,
    y: -3,
    width: 41.1104,
    height: 41.1104,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20.707,
    y: 38.1104,
    width: 41.1104,
    height: 41.1104,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4062,
    y: -3,
    width: 41.1104,
    height: 41.1104,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4062,
    y: 38.1104,
    width: 41.1104,
    height: 41.1104,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 15.4518,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 18.3199,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 21.1881,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 24.0562,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 26.9234,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 29.7926,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 32.6598,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 35.5289,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 38.3961,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 41.2643,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 44.1324,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 47.0006,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 49.8707,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 52.7369,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 55.6051,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.06602,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.9332,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8004,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.6676,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5387,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4059,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.273,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1441,
    cy: 58.4723,
    r: 0.382422,
    fill: "#D9D9D9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.223 13.3293H26.7967V12.7557H26.223V13.3293ZM26.223 59V59.5736H26.7967V59H26.223ZM15.6523 59H15.0786V59.5736H15.6523V59ZM15.6523 25.2488H16.2259V24.4836L15.4914 24.6982L15.6523 25.2488ZM5.23833 28.2915H4.6647V29.0567L5.3992 28.8421L5.23833 28.2915ZM5.23833 20.2614L5.05057 19.7194L4.6647 19.8531V20.2614H5.23833ZM25.2506 13.3293V12.7557H25.1541L25.0629 12.7872L25.2506 13.3293ZM25.6494 13.3293V59H26.7967V13.3293H25.6494ZM26.223 58.4264H15.6523V59.5736H26.223V58.4264ZM16.2259 59V25.2488H15.0786V59H16.2259ZM15.4914 24.6982L5.07746 27.7408L5.3992 28.8421L15.8131 25.7995L15.4914 24.6982ZM5.81196 28.2915V20.2614H4.6647V28.2915H5.81196ZM5.42609 20.8035L25.4384 13.8713L25.0629 12.7872L5.05057 19.7194L5.42609 20.8035ZM25.2506 13.9029H26.223V12.7557H25.2506V13.9029Z",
    fill: "#202124"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_623_16124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 26,
    width: 24,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.514 35.4166V42.0825H83.495V35.4166H106.514ZM98.6721 26.6517V51.1012H91.4065V26.6517H98.6721Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_623_16124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.9336,
    y: 7.9375,
    width: 30.2301,
    height: 30.2301,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.9336,
    y: 38.167,
    width: 30.2301,
    height: 30.2301,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1641,
    y: 7.9375,
    width: 30.2301,
    height: 30.2301,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1641,
    y: 38.167,
    width: 30.2301,
    height: 30.2301,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 27.833,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 29.9433,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 32.0498,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 34.1591,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 36.2675,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 38.3759,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 40.4853,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 42.5957,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 44.7031,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 46.8144,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 48.9218,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.4961,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6093,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.7226,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.8242,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.9414,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.0507,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1601,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.2656,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.375,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.484,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.594,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.703,
    cy: 51.0312,
    r: 0.28121,
    fill: "#D9D9D9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.057 34.9478H106.479V34.526H106.057V34.9478ZM106.057 41.6138V42.0356H106.479V41.6138H106.057ZM83.038 41.6138H82.6161V42.0356H83.038V41.6138ZM83.038 34.9478V34.526H82.6161V34.9478H83.038ZM98.2151 26.1829H98.6369V25.7611H98.2151V26.1829ZM98.2151 50.6324V51.0542H98.6369V50.6324H98.2151ZM90.9494 50.6324H90.5276V51.0542H90.9494V50.6324ZM90.9494 26.1829V25.7611H90.5276V26.1829H90.9494ZM105.636 34.9478V41.6138H106.479V34.9478H105.636ZM106.057 41.192H83.038V42.0356H106.057V41.192ZM83.4598 41.6138V34.9478H82.6161V41.6138H83.4598ZM83.038 35.3696H106.057V34.526H83.038V35.3696ZM97.7933 26.1829V50.6324H98.6369V26.1829H97.7933ZM98.2151 50.2106H90.9494V51.0542H98.2151V50.2106ZM91.3713 50.6324V26.1829H90.5276V50.6324H91.3713ZM90.9494 26.6047H98.2151V25.7611H90.9494V26.6047Z",
    fill: "#202124"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_623_16124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 14,
    width: 33,
    height: 48
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.224 40.297L41.8176 38.3208L44.5779 14.9836H71.2714V23.2018H53.2039L52.1688 32.2669C52.6707 31.9742 53.5176 31.6291 54.7095 31.2318C55.9224 30.8136 57.2607 30.6045 58.7245 30.6045C60.983 30.6045 62.98 30.9495 64.7157 31.6396C66.4722 32.3088 67.957 33.3021 69.1698 34.6195C70.3827 35.916 71.2923 37.5157 71.8988 39.4187C72.5261 41.3216 72.8398 43.4964 72.8398 45.9431C72.8398 47.9087 72.5157 49.8117 71.8674 51.6519C71.2401 53.4712 70.2677 55.1127 68.9503 56.5766C67.6537 58.0194 66.0122 59.1696 64.0256 60.027C62.039 60.8634 59.6865 61.2816 56.968 61.2816C54.9396 61.2816 52.9634 60.968 51.0396 60.3406C49.1157 59.7133 47.38 58.8141 45.8326 57.643C44.3061 56.4511 43.0932 55.0186 42.194 53.3457C41.3157 51.6519 40.887 49.7594 40.9079 47.6683H51.5414C51.6042 48.7766 51.8656 49.7385 52.3256 50.554C52.7857 51.3696 53.4026 52.0074 54.1763 52.4674C54.9709 52.9066 55.8806 53.1262 56.9052 53.1262C57.9508 53.1262 58.8186 52.917 59.5087 52.4988C60.1988 52.0806 60.7425 51.5055 61.1398 50.7736C61.5371 50.0417 61.8194 49.2053 61.9867 48.2642C62.154 47.3023 62.2377 46.2881 62.2377 45.2216C62.2377 44.0924 62.1122 43.0782 61.8613 42.179C61.6312 41.2798 61.2548 40.5165 60.732 39.8892C60.2092 39.2409 59.5296 38.7495 58.6932 38.4149C57.8776 38.0803 56.8948 37.913 55.7446 37.913C54.2181 37.913 53.0157 38.1744 52.1374 38.6972C51.2591 39.22 50.6213 39.7533 50.224 40.297Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_623_16124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.2031,
    y: -2.0918,
    width: 41.1104,
    height: 41.1104,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2031,
    y: 39.0176,
    width: 41.1104,
    height: 41.1104,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3125,
    y: -2.0918,
    width: 41.1104,
    height: 41.1104,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3125,
    y: 39.0176,
    width: 41.1104,
    height: 41.1104,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 16.359,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 19.2281,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 22.0953,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 24.9635,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 27.8336,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 30.7008,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 33.5689,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 36.4361,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 39.3053,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 42.1725,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 45.0416,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 47.9078,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 50.7779,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 53.6441,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 56.5143,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9762,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.8434,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.7105,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5777,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4488,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.316,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.1832,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.0543,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.9215,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.7887,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6598,
    cy: 59.3805,
    r: 0.382422,
    fill: "#D9D9D9"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1732 39.3409L49.042 39.8993L49.4121 39.9863L49.6364 39.6794L49.1732 39.3409ZM40.7668 37.3648L40.1971 37.2974L40.137 37.806L40.6355 37.9232L40.7668 37.3648ZM43.5271 14.0275V13.4539H43.0173L42.9575 13.9601L43.5271 14.0275ZM70.2206 14.0275H70.7943V13.4539H70.2206V14.0275ZM70.2206 22.2457V22.8194H70.7943V22.2457H70.2206ZM52.1531 22.2457V21.6721H51.6413L51.5832 22.1807L52.1531 22.2457ZM51.118 31.3109L50.5481 31.2458L50.4182 32.3832L51.407 31.8064L51.118 31.3109ZM53.6587 30.2758L53.8402 30.82L53.8457 30.8181L53.6587 30.2758ZM63.6649 30.6835L63.4529 31.2166L63.4607 31.2196L63.6649 30.6835ZM68.119 33.6634L67.697 34.052L67.7001 34.0553L68.119 33.6634ZM70.848 38.4626L70.3014 38.6368L70.3032 38.6422L70.848 38.4626ZM70.8166 50.6958L70.2756 50.5052L70.2743 50.5088L70.8166 50.6958ZM67.8995 55.6205L67.4731 55.2368L67.4728 55.2371L67.8995 55.6205ZM62.9748 59.0709L63.1974 59.5996L63.2021 59.5976L62.9748 59.0709ZM44.7818 56.687L44.4287 57.1392L44.4357 57.1444L44.7818 56.687ZM41.1432 52.3897L40.6339 52.6538L40.6379 52.6613L41.1432 52.3897ZM39.8572 46.7122V46.1386H39.2892L39.2835 46.7065L39.8572 46.7122ZM50.4907 46.7122L51.0634 46.6798L51.0327 46.1386H50.4907V46.7122ZM53.1255 51.5114L52.8323 52.0044L52.8401 52.0091L52.848 52.0135L53.1255 51.5114ZM60.9359 47.3082L61.5007 47.4086L61.5011 47.4065L60.9359 47.3082ZM60.8105 41.2229L60.2546 41.3651L60.258 41.3771L60.8105 41.2229ZM59.6813 38.9331L59.2347 39.2933L59.2406 39.3004L59.6813 38.9331ZM57.6424 37.4589L57.4247 37.9896L57.4293 37.9915L57.6424 37.4589ZM49.3045 38.7825L40.8981 36.8063L40.6355 37.9232L49.042 39.8993L49.3045 38.7825ZM41.3365 37.4321L44.0968 14.0949L42.9575 13.9601L40.1971 37.2974L41.3365 37.4321ZM43.5271 14.6012H70.2206V13.4539H43.5271V14.6012ZM69.647 14.0275V22.2457H70.7943V14.0275H69.647ZM70.2206 21.6721H52.1531V22.8194H70.2206V21.6721ZM51.5832 22.1807L50.5481 31.2458L51.6879 31.376L52.723 22.3108L51.5832 22.1807ZM51.407 31.8064C51.8542 31.5455 52.6528 31.2157 53.8401 30.82L53.4773 29.7316C52.2808 30.1304 51.3856 30.4907 50.829 30.8154L51.407 31.8064ZM53.8457 30.8181C54.9906 30.4233 56.2647 30.222 57.6738 30.222V29.0748C56.1551 29.0748 54.7526 29.2918 53.4717 29.7335L53.8457 30.8181ZM57.6738 30.222C59.8744 30.222 61.7972 30.5583 63.453 31.2166L63.8768 30.1505C62.0612 29.4286 59.99 29.0748 57.6738 29.0748V30.222ZM63.4607 31.2196C65.1384 31.8587 66.5474 32.8032 67.697 34.052L68.5411 33.2749C67.265 31.8888 65.7045 30.8467 63.8691 30.1475L63.4607 31.2196ZM67.7001 34.0553C68.8479 35.2823 69.7176 36.8048 70.3014 38.6368L71.3945 38.2884C70.7655 36.3145 69.8159 34.6376 68.538 33.2715L67.7001 34.0553ZM70.3032 38.6422C70.9078 40.476 71.2154 42.5884 71.2154 44.987H72.3626C72.3626 42.4923 72.0429 40.2551 71.3928 38.283L70.3032 38.6422ZM71.2154 44.987C71.2154 46.8883 70.9021 48.7267 70.2756 50.5052L71.3577 50.8864C72.0277 48.9845 72.3626 47.0171 72.3626 44.987H71.2154ZM70.2743 50.5088C69.6726 52.2537 68.7403 53.8287 67.4731 55.2368L68.3259 56.0042C69.6935 54.4847 70.7059 52.7765 71.3589 50.8828L70.2743 50.5088ZM67.4728 55.2371C66.2377 56.6116 64.6669 57.7158 62.7475 58.5442L63.2021 59.5976C65.2559 58.7112 66.9682 57.5152 68.3262 56.0039L67.4728 55.2371ZM62.7522 58.5422C60.8519 59.3424 58.5785 59.752 55.9172 59.752V60.8992C58.6929 60.8992 61.1246 60.4724 63.1974 59.5996L62.7522 58.5422ZM55.9172 59.752C53.949 59.752 52.0329 59.4478 50.1666 58.8392L49.8109 59.9299C51.7924 60.5761 53.8285 60.8992 55.9172 60.8992V59.752ZM50.1666 58.8392C48.3007 58.2308 46.6224 57.3605 45.128 56.2296L44.4357 57.1444C46.0361 58.3555 47.8291 59.2837 49.8109 59.9299L50.1666 58.8392ZM45.1348 56.2349C43.6698 55.0909 42.5092 53.7195 41.6485 52.1181L40.6379 52.6613C41.5756 54.4057 42.8408 55.8992 44.4288 57.1391L45.1348 56.2349ZM41.6525 52.1256C40.8214 50.5229 40.4107 48.7244 40.4308 46.7179L39.2835 46.7065C39.2618 48.8823 39.7084 50.8688 40.634 52.6537L41.6525 52.1256ZM39.8572 47.2858H50.4907V46.1386H39.8572V47.2858ZM49.9179 46.7446C49.9847 47.9244 50.2647 48.9749 50.7752 49.8798L51.7745 49.3162C51.3648 48.59 51.1221 47.7166 51.0634 46.6798L49.9179 46.7446ZM50.7752 49.8798C51.2824 50.7789 51.969 51.4911 52.8323 52.0044L53.4187 51.0183C52.7346 50.6116 52.1874 50.0481 51.7745 49.3162L50.7752 49.8798ZM52.848 52.0135C53.7381 52.5053 54.7454 52.7437 55.8545 52.7437V51.5965C54.9142 51.5965 54.1022 51.3957 53.403 51.0093L52.848 52.0135ZM55.8545 52.7437C56.9745 52.7437 57.9527 52.5197 58.7552 52.0333L58.1606 51.0522C57.583 51.4022 56.8256 51.5965 55.8545 51.5965V52.7437ZM58.7552 52.0333C59.5351 51.5607 60.149 50.9095 60.5932 50.0912L59.5849 49.5439C59.2344 50.1894 58.7609 50.6884 58.1606 51.0522L58.7552 52.0333ZM60.5932 50.0912C61.0238 49.2979 61.3242 48.4014 61.5007 47.4086L60.3712 47.2078C60.2131 48.0969 59.9488 48.8734 59.5849 49.5439L60.5932 50.0912ZM61.5011 47.4065C61.6745 46.4093 61.7605 45.362 61.7605 44.2656H60.6132C60.6132 45.3021 60.532 46.2832 60.3708 47.2099L61.5011 47.4065ZM61.7605 44.2656C61.7605 43.0947 61.6305 42.0273 61.363 41.0687L60.258 41.3771C60.4923 42.2169 60.6132 43.178 60.6132 44.2656H61.7605ZM61.3662 41.0808C61.1179 40.1102 60.7063 39.2672 60.1219 38.5659L59.2406 39.3004C59.7017 39.8537 60.043 40.5372 60.2547 41.3651L61.3662 41.0808ZM60.1278 38.573C59.5382 37.842 58.7755 37.2943 57.8554 36.9263L57.4293 37.9915C58.1822 38.2926 58.7787 38.7277 59.2347 39.2932L60.1278 38.573ZM57.8601 36.9282C56.9579 36.558 55.897 36.3834 54.6939 36.3834V37.5306C55.791 37.5306 56.6958 37.6905 57.4247 37.9896L57.8601 36.9282ZM54.6939 36.3834C53.1114 36.3834 51.7937 36.6528 50.7932 37.2482L51.38 38.2341C52.1362 37.784 53.2232 37.5306 54.6939 37.5306V36.3834ZM50.7932 37.2482C49.8796 37.7921 49.1703 38.3726 48.7101 39.0024L49.6364 39.6794C49.9708 39.2218 50.5371 38.7358 51.38 38.2341L50.7932 37.2482Z",
    fill: "#202124"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.e29e4c16ff0cc2d5d4821a47015ff3fc.svg";
export { ForwardRef as ReactComponent };